module.exports = {
  asc: 'asc',
  desc: 'desc',
};
